module.exports = __webpack_public_path__ + "img/cu.b05c8f24.svg";